import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { SidebarItemStore } from '@core/components/sidebar/components/sidebar-item/sidebar-item.store';
import { SidebarService } from '@core/components/sidebar/service/sidebar.service';
import { SidebarItemExpandedLayoutComponent } from '@core/components/sidebar/components/sidebar-item/item/expanded/layout/sidebar-item-expanded-layout.component';

@Component({
  selector: 'app-sidebar-item-expanded-link',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, SidebarItemExpandedLayoutComponent],
  template: `
    <a
      routerLinkActive
      (isActiveChange)="updateActiveRoute(mainPath(), $event)"
      [routerLinkActiveOptions]="{ exact: false }"
      routerLink="/{{ mainPath() }}">
      <app-sidebar-item-expanded-layout [isActive]="isActive()" />
    </a>
  `,
})
export class SidebarItemExpandedLinkComponent {
  /** INJECTIONS **/
  /****/
  private readonly store = inject(SidebarItemStore);

  /****/
  private readonly service = inject(SidebarService);

  /** PROPERTIES **/
  /****/
  protected readonly mainPath = this.store.mainPath;

  /****/
  private readonly _activeRoute = toSignal(this.service.routeChanged$);

  /****/
  protected readonly isActive = computed(
    () => this._activeRoute() === this.mainPath()
  );

  protected updateActiveRoute(route: string, active: boolean) {
    this.service.setActiveRoute(route, active);
  }
}
